import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { API } from 'aws-amplify';
import { listMessages } from 'graphql/queries';
import { useUser } from 'hooks/useUser';
import RDDashboard from 'components/RDDashboard';
import RDMessageBox from 'components/RDMessageBox';
import WelcomeMessage from './components/WelcomeMessage';
import { getHomeConfig } from './config';

/**
 * HomePage Component
 *
 * Default landing page for authenticated users.
 * Uses RDDashboard layout with:
 * - Banner with client-specific background image
 * - Overlapping identity bar with logo and user info
 * - For GRM: Active messages from Message component (same as Dashboard Home Base)
 * - For other clients: Simple welcome message
 *
 * GRM displays active messages fetched from the database.
 * Other clients display a welcome message card.
 */
export default function HomePage() {
  const { user } = useUser();
  const clientId = user?.client;

  const [activeMessages, setActiveMessages] = useState([]);
  const [messagesToDisplay, setMessagesToDisplay] = useState(false);

  // Get client-specific configuration
  const config = getHomeConfig(user?.client);

  // Check if this is a GRM client
  const isGRM = clientId === 'grm';

  useEffect(() => {
    if (activeMessages.length > 0) {
      setMessagesToDisplay(true);
    } else {
      setMessagesToDisplay(false);
    }
  }, [activeMessages]);

  useEffect(() => {
    if (clientId && isGRM) {
      fetchMessages();
    }
  }, [clientId, isGRM]);

  async function fetchMessages() {
    try {
      const queryResponse = await API.graphql({
        query: listMessages,
        variables: {
          clientId: clientId,
          status: 'active'
        }
      });
      console.log('messages fetched successfully', queryResponse);
      setActiveMessages(queryResponse.data.listMessages);
    } catch (err) {
      console.log('Error fetching messages', err);
    }
  }

  return (
    <RDDashboard
      headerBg={config.headerBg}
      logo={config.logo}
    >
      {isGRM ? (
        messagesToDisplay && (
          <RDMessageBox
            messages={activeMessages}
            noteColor='#f9e9d3'
            textColor='#000'
          />
        )
      ) : (
        <Grid item xs={12}>
          <WelcomeMessage user={user} config={config} />
        </Grid>
      )}
    </RDDashboard>
  );
}
